import { DeletePartnerMaterialResponseSchema } from './delete-partner-material.schema';
export const deletePartnerMaterialContract = {
    method: 'DELETE',
    path: '/api/v2/admin/partner-materials/:id',
    description: 'Delete a partner material and its stored files',
    responseSchema: DeletePartnerMaterialResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - superadmin only',
            404: 'Partner material not found'
        }
    }
};

//# sourceMappingURL=delete-partner-material.contract.js.map